<template>
    <div class="modal-recharge">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">查询所要退款的老人</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <el-form :model="searchForm" inline ref="searchForm">
                        <div>
                            <el-col :span="24">
                                <el-form-item prop="name">
                                    <el-input  placeholder="请输入姓名" v-model="searchForm.name" clearable style="width:200px;margin-right:10px"></el-input>
                                </el-form-item>
                                
                                <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                            </el-col>
                        </div>
                    </el-form>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border :height="th">
                            <el-table-column label="老人姓名" prop="name" width="100"></el-table-column>
                            <el-table-column label="手机号" prop="phone" width="120"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard" width="200"></el-table-column>
                            <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
                            <el-table-column prop="deposit"  width="100" label="预交金(元)"></el-table-column>
                            <el-table-column prop="imprest"  width="100" label="备用金(元)"></el-table-column>
                            <el-table-column label="地址" prop="areaName"></el-table-column>
                            <el-table-column label="详细住址" prop="address"></el-table-column>
                            
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleRecharge(scope.row)">退款</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                    <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）
                    </div>
                    <div style="float: left;">
                        <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="totalItems"
                                :page-size="20"
                                @current-change="current_change">
                        </el-pagination>
                    </div>
                    <div style="clear: both;"></div>
                </div>
            </div>
        </div>
        <el-dialog title='退款' :visible.sync="rechargeDialog" :modal-append-to-body='false' @close='closeRechargeForm' class="dialog" width='400px' center top='20vh' :close-on-click-modal='false'>
            <el-form :model="rechargeForm" :rules="rules" ref="rechargeForm">
                <div>
                    <el-row>
                        <el-col :span="24" class="item">
                            <el-form-item label="退款金额" required prop="addBalance">
                                <el-input v-model="rechargeForm.addBalance" type="number" placeholder="请输入退款金额"></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="24" class="item">
                            <el-form-item label="退款类型" required prop="refundType">
                                <el-select v-model="rechargeForm.refundType" placeholder="请选择充值类型" style="width:100%">
                                    <el-option
                                            v-for="item in typeValue"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="24" class="item">
                            <el-form-item label="预交备注">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder="备注信息"
                                    v-model="rechargeForm.remarks">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rechargeDialog=false">取 消</el-button>
                <el-button type="primary"  @click="confirm('rechargeForm')">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                showModalRecharge:false,
                verificationDialog:false,
                voucherDialog:false,
                rechargeDialog:false,
                verifiyForm:{
                    verifiyBalance:'',
                },
                multipleSelection:'',
                checked:false,
                loading: false, 
                elderlyInfo:[],
                elderlyRow:'',
                statusValue:['全部状态','正常','禁用'],
                totalItems:0,
                searchForm:{
                    name:'',
                    status:0,
                    pageSize:20,
                    pageIndex:1,
                },
                rechargeForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    remarks:'',
                    addBalance:'',
                    // refundType:''
                },
                typeValue:[{value:1,label:"现金"},{value:3,label:"支付宝"},{value:4,label:"微信"}],
                rules:{
                    addBalance:[
                        { required: true, message: '请输入预交金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ],
                    // refundType:[
                    //     { required: true, message: '请选择充值类型', trigger: 'blur' }
                    // ],
                },
                verifiyRules:{
                    verifiyBalance:[
                        { required: true, message: '请输入预交金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位"
                        }
                    ]
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight,
                successInfo:''
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val
            },
        },
        components:{
            // Recharge
        },
        methods: {
            init(){
                this.$refs.searchForm.resetFields()
                this.getElderly()
            },
            formatterTime(cellValue) {
                return timefilters(cellValue)
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            getList(){
                this.$emit("getList");
                this.getElderly();
            },
          
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            handleRecharge(row) {
                this.elderlyRow=row
                this.rechargeForm.elderlyCode=row.elderlyCode
                this.rechargeDialog=true
            },
            closeRechargeForm(){
                this.$refs.rechargeForm.resetFields();
                this.rechargeForm.remarks=''
            },
            closeVerifiyForm(){
                this.loading=false
                this.$refs.verifiyForm.resetFields();
            },
            getElderly(){
                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/Page",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            confirm(rechargeForm){
                this.$refs[rechargeForm].validate((valid) => {
                    if(valid){
                        // this.rechargeDialog=false
                        // this.verificationDialog=true
                        this.addSubmit()
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })
            },
            addSubmit(){
                this.rechargeForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundAudit/Add",
                    data: this.rechargeForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.rechargeDialog=false
                            this.$message.success('提交成功，请等待审核！')
                            this.$emit('getList')
                            this.getElderly()
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>
    
    .modal-recharge {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;
        .dialog /deep/ .is-disabled .el-input__inner {
            background-color: #F5F7FA;
            border-color: #E4E7ED;
            color: #000;
            cursor: not-allowed;
        }
        .text{
            font-size: 16px;
            line-height: 25px;
        }
        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-form-item{
                margin: 0 5px 0 0;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
